export const version = "6.0.2";
//# sourceMappingURL=_version.js.map